/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Duration_PlaceholderInputs */

const en_candidate_profile_duration_placeholder = /** @type {(inputs: Candidate_Profile_Duration_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g., 6 months, Permanent`)
};

const de_candidate_profile_duration_placeholder = /** @type {(inputs: Candidate_Profile_Duration_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. 6 Monate, Unbefristet`)
};

/**
* | output |
* | --- |
* | "e.g., 6 months, Permanent" |
*
* @param {Candidate_Profile_Duration_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_duration_placeholder = /** @type {((inputs?: Candidate_Profile_Duration_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Duration_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_duration_placeholder(inputs)
	return en_candidate_profile_duration_placeholder(inputs)
});